import {
  ADD_MARKER_TO_FORMULA,
  CANCEL_FORMULA_EDIT,
  EFormulaModalType,
  IFormulaEntryState,
  SET_CURSOR_POSITION,
  START_FORMULA_EDIT,
  UPDATE_FIELD,
  GET_MARKERS,
  GET_MARKERS_FAIL,
  GET_MARKERS_SUCCESS,
  UPDATE_MARKER_LIST_FORMULA,
  IMarker,
} from 'store/formula-entry/types';

export const initialState: IFormulaEntryState = {
  modalType: null,
  availableMarkers: null,
  productIndex: null,
  markerList: [],
};

interface IActionAddMarkerToFormula {
  type: typeof ADD_MARKER_TO_FORMULA;
  marker: string;
}

interface IActionStartFormulaEdit {
  type: typeof START_FORMULA_EDIT;
  descriptionInputValue: string;
  formulaInputValue: string;
  modalType: EFormulaModalType;
  productIndex: number;
}

interface IActionSetCursorPosition {
  type: typeof SET_CURSOR_POSITION;
  cursorPosition: number;
}

interface IActionCancelFormulaEdit {
  type: typeof CANCEL_FORMULA_EDIT;
}

interface IActionUpdateField {
  type: typeof UPDATE_FIELD;
  field: string;
  value: string;
}

interface IActionGetMarkers {
  type: typeof GET_MARKERS;
}

interface IActionGetMarkersFail {
  type: typeof GET_MARKERS_FAIL;
  error: Error;
}

interface IActionGetMarkersSuccess {
  type: typeof GET_MARKERS_SUCCESS;
  markers: IMarker[];
}

interface IActionMarkerList {
  type: typeof UPDATE_MARKER_LIST_FORMULA;
  markerList: IMarker[];
}

type TAction =
  | IActionAddMarkerToFormula
  | IActionSetCursorPosition
  | IActionStartFormulaEdit
  | IActionCancelFormulaEdit
  | IActionUpdateField
  | IActionGetMarkers
  | IActionGetMarkersFail
  | IActionGetMarkersSuccess
  | IActionMarkerList;

export default (state = initialState, action: TAction) => {
  switch (action.type) {
    case CANCEL_FORMULA_EDIT: {
      return {
        ...initialState,
        availableMarkers: state.availableMarkers,
      };
    }

    case GET_MARKERS: {
      return {
        ...state,
        loading: true,
      };
    }

    case GET_MARKERS_FAIL: {
      return {
        ...state,
        loading: false,
        error: action.error,
      };
    }

    case GET_MARKERS_SUCCESS: {
      return {
        ...state,
        loading: false,
        availableMarkers: action.markers.map((marker: IMarker) => {
          if (marker.isFavorite) {
            return { ...marker, types: 'preferred' };
          }
          return marker;
        }),
      };
    }

    case SET_CURSOR_POSITION: {
      return {
        ...state,
        cursorPosition: action.cursorPosition,
      };
    }

    case START_FORMULA_EDIT: {
      const { descriptionInputValue, formulaInputValue, modalType, productIndex } = action;
      return {
        ...state,
        descriptionInputValue,
        filteredMarkers: state.availableMarkers,
        markerSearchInputValue: '',
        formulaInputValue,
        modalType,
        productIndex,
      };
    }

    case UPDATE_FIELD: {
      return {
        ...state,
        [action.field]: action.value,
      };
    }

    case UPDATE_MARKER_LIST_FORMULA: {
      const { markerList } = action;
      return {
        ...state,
        markerList,
      };
    }
    default: {
      return state;
    }
  }
};
